const Logout = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4">
      <h1 className="text-2xl font-light">You've been signed out.</h1>
      <a href={window.location.origin}>
        <button className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/80 transition-colors">
          Go back home
        </button>
      </a>
    </div>
  );
};

export default Logout;
